import Button, { ButtonVariants } from 'components/base/Button';

import TwitterIcon from 'assets/icons/twitter.svg';
import { getShareOnTwitterUrl } from 'utils/twitter';

export interface TwitterShareButtonLinkProps {
  size?: ButtonVariants['size'];
  text?: string;
  twitterShareText: string;
  variant?: ButtonVariants['variant'];
}

export default function TwitterShareButtonLink(
  props: TwitterShareButtonLinkProps
) {
  const {
    size,
    text = 'Tweet it',
    twitterShareText,
    variant = 'primary',
  } = props;
  return (
    <Button
      as="a"
      css={{ width: '100%' }}
      href={getShareOnTwitterUrl({
        post: twitterShareText,
      })}
      icon
      rel="noopener noreferrer"
      size={size}
      target="_blank"
      type="button"
      variant={variant}
    >
      <TwitterIcon />
      <span>{text}</span>
    </Button>
  );
}
